module.exports = __webpack_public_path__ + "static/media/searchIconWhite.b9b1ad8c.svg";